import React, { useState } from "react";
import Button from "./Button";
import CustomModal from "./CustomModal";
import GranularPermissionModal from "../../../../components/Permissions/GranularPermissionModal";
import { checkWidgetAdminOrNot } from "../../../../utils/Constants";

const PermissionButton = ({ moduleName, widgetName, activityName, header }) => {
  const [permissionModal, setPermissionModal] = useState(false);

  return (
    <>
      {checkWidgetAdminOrNot(widgetName) && (
        <>
          <Button
            variant={"outline"}
            onClick={() => setPermissionModal((prev) => !prev)}
          >
            Permission
          </Button>

          <CustomModal
            isOpen={permissionModal}
            toggle={() => setPermissionModal((prev) => !prev)}
            modalHeader={"Assign Permission to User"}
            children={
              <GranularPermissionModal
                moduleName={moduleName}
                widgetName={widgetName}
                header={header}
                activityName={activityName}
              />
            }
          />
        </>
      )}
    </>
  );
};

export default PermissionButton;
